(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  function initBundleBuilder(section) {
    var currency = section.dataset.currency || 'USD';
    var discountPercent = parseFloat(section.dataset.discount) || 0;
    var discountCode = section.dataset.discountCode || '';
    var loadingText = section.dataset.loadingText || 'Adding...';
    var errorText = section.dataset.errorText || 'Something went wrong. Please try again.';

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-product]'));
    var summary = section.querySelector('[data-bundle-summary]');
    var submitButton = section.querySelector('[data-bundle-submit]');
    var submitText = section.querySelector('[data-bundle-submit-text]');
    var errorEl = section.querySelector('[data-bundle-error]');
    var originalTotalEl = section.querySelector('[data-bundle-original-total]');
    var savingsEl = section.querySelector('[data-bundle-savings]');
    var totalEl = section.querySelector('[data-bundle-total]');

    var originalSubmitLabel = submitText ? submitText.textContent : '';
    var formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      });
    } catch (e) {
      formatter = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' });
    }

    var products = [];

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function fetchProducts() {
      return Promise.all(
        cards.map(function (card) {
          var handle = card.dataset.productHandle;
          return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (response) {
            if (!response.ok) {
              throw new Error('product_fetch_failed');
            }
            return response.json();
          });
        })
      );
    }

    fetchProducts()
      .then(function (results) {
        results.forEach(function (data, index) {
          var card = cards[index];
          var variant = data.variants && data.variants[0];
          if (!variant) {
            throw new Error('no_variant_available');
          }

          products.push({ variantId: variant.id, price: variant.price });

          var priceEl = card.querySelector('[data-bundle-price]');
          if (priceEl) {
            priceEl.textContent = formatter.format(variant.price / 100);
          }
        });

        var originalTotalCents = products.reduce(function (sum, product) {
          return sum + product.price;
        }, 0);
        var savingsCents = Math.round(originalTotalCents * (discountPercent / 100));
        var bundleTotalCents = originalTotalCents - savingsCents;

        if (originalTotalEl) originalTotalEl.textContent = formatter.format(originalTotalCents / 100);
        if (savingsEl) savingsEl.textContent = '-' + formatter.format(savingsCents / 100);
        if (totalEl) totalEl.textContent = formatter.format(bundleTotalCents / 100);
        if (summary) summary.hidden = false;
        if (submitButton) submitButton.disabled = false;
      })
      .catch(function () {
        showError(errorText);
      });

    if (submitButton) {
      submitButton.addEventListener('click', function () {
        if (submitButton.disabled || products.length === 0) return;

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        if (errorEl) errorEl.hidden = true;
        if (submitText) submitText.textContent = loadingText;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: products.map(function (product) {
              return { id: product.variantId, quantity: 1 };
            })
          })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function () {
                throw new Error('cart_add_failed');
              });
            }
            return response.json();
          })
          .then(function () {
            var cartUrl = discountCode ? '/cart?discount=' + encodeURIComponent(discountCode) : '/cart';
            window.location.href = cartUrl;
          })
          .catch(function () {
            showError(errorText);
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
            if (submitText) submitText.textContent = originalSubmitLabel;
          });
      });
    }
  }

  var bundleBuilderSections = document.querySelectorAll('[data-bundle-builder]');
  for (var i = 0; i < bundleBuilderSections.length; i++) {
    initBundleBuilder(bundleBuilderSections[i]);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foiluxmas-good-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LOG = '[FGL]';

    function initFoiluxmasGoodList(root) {
      try {
        if (!root || root.dataset.fglInit === 'true') return;
        root.dataset.fglInit = 'true';

        var yourNameEl = root.querySelector('.foiluxmas-good-list__yourname');
        var noteTextEl = root.querySelector('.foiluxmas-good-list__next-note span');
        var progressEl = root.querySelector('.foiluxmas-good-list__progress');
        var placeholder = root.querySelector('[data-forms-id^="forms-root-"]');

        console.debug(LOG, 'init', { root: root, placeholder: placeholder });

        if (!placeholder) {
          console.debug(LOG, 'no [data-forms-id^="forms-root-"] placeholder found inside this section; nothing to attach to.');
          return;
        }

        var capturedName = '';
        var hasFired = false;

        function isNameField(target) {
          if (!target || target.tagName !== 'INPUT') return false;
          var type = (target.getAttribute('type') || 'text').toLowerCase();
          if (['email', 'hidden', 'checkbox', 'radio', 'submit', 'button'].indexOf(type) !== -1) return false;

          var name = (target.getAttribute('name') || '').toLowerCase();
          var autocomplete = (target.getAttribute('autocomplete') || '').toLowerCase();
          var id = (target.id || '').toLowerCase();
          var ph = (target.getAttribute('placeholder') || '').toLowerCase();
          var labelText = '';
          if (target.labels && target.labels.length) {
            labelText = (target.labels[0].textContent || '').toLowerCase();
          }

          if (name === 'name' || autocomplete === 'name' || id === 'name') return true;
          if (
            name.indexOf('email') !== -1 ||
            autocomplete.indexOf('email') !== -1 ||
            id.indexOf('email') !== -1 ||
            ph.indexOf('email') !== -1 ||
            labelText.indexOf('email') !== -1
          ) {
            return false;
          }

          var hint = name + ' ' + autocomplete + ' ' + id + ' ' + ph + ' ' + labelText;
          return hint.indexOf('name') !== -1;
        }

        function tryCaptureName(target) {
          if (isNameField(target)) {
            capturedName = target.value;
            console.debug(LOG, 'captured name field value:', capturedName, target);
          }
        }

        function applyDisplayName() {
          if (!yourNameEl) return;
          var displayName = (capturedName || '').trim();
          if (!displayName) {
            console.debug(LOG, 'success fired but no name was captured; leaving placeholder text as-is.');
            return;
          }

          yourNameEl.textContent = displayName;
          yourNameEl.classList.toggle('foiluxmas-good-list__yourname--long', displayName.length > 14);
        }

        function onSuccess() {
          if (hasFired) return;
          hasFired = true;
          console.debug(LOG, 'SUCCESS detected — updating Good List visuals.');

          if (progressEl) progressEl.style.display = 'none';

          applyDisplayName();

          if (noteTextEl) noteTextEl.textContent = 'You made the list!';
        }

        function checkStep(shadowRoot) {
          var appEmbedEl = shadowRoot.getElementById && shadowRoot.getElementById('app-embed');
          if (!appEmbedEl) return;
          var step = (appEmbedEl.getAttribute('data-current-step') || '').toLowerCase();
          if (step) console.debug(LOG, 'current step:', step);
          if (step === 'success') onSuccess();
        }

        function watchShadow(shadowHost) {
          if (!shadowHost || shadowHost.__fglObserved) return;
          var shadowRoot = shadowHost.shadowRoot;
          if (!shadowRoot) return;
          shadowHost.__fglObserved = true;

          console.debug(LOG, 'attached to shadow root on', shadowHost);

          shadowRoot.addEventListener(
            'input',
            function (event) {
              tryCaptureName(event.target);
            },
            true
          );
          shadowRoot.addEventListener(
            'change',
            function (event) {
              tryCaptureName(event.target);
            },
            true
          );

          checkStep(shadowRoot);

          var stepObserver = new MutationObserver(function () {
            checkStep(shadowRoot);
          });
          stepObserver.observe(shadowRoot, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['data-current-step'],
          });
        }

        function findShadowHost() {
          // Shopify Forms appends an element with id="app-embed" as a
          // direct light-DOM child of our placeholder div, then attaches
          // its own shadow root to it.
          var byId = placeholder.querySelector('#app-embed');
          if (byId && byId.shadowRoot) return byId;

          // Fallback: any appended child that happens to carry a shadow
          // root, in case the id ever changes.
          var children = placeholder.querySelectorAll('*');
          for (var i = 0; i < children.length; i++) {
            if (children[i].shadowRoot) return children[i];
          }
          return null;
        }

        function tryAttach() {
          var host = findShadowHost();
          if (host) {
            watchShadow(host);
            return true;
          }
          return false;
        }

        if (!tryAttach()) {
          console.debug(LOG, 'waiting for Shopify Forms to mount inside the placeholder…');

          var placeholderObserver = new MutationObserver(function () {
            if (tryAttach()) placeholderObserver.disconnect();
          });
          placeholderObserver.observe(placeholder, { childList: true, subtree: true });

          var attempts = 0;
          var poll = setInterval(function () {
            attempts += 1;
            if (tryAttach() || attempts > 80) {
              clearInterval(poll);
              placeholderObserver.disconnect();
              if (attempts > 80) {
                console.debug(LOG, 'gave up waiting for Shopify Forms to mount after 20s.');
              }
            }
          }, 250);
        }
      } catch (error) {
        console.debug(LOG, 'unexpected error (safely ignored, does not affect the real form):', error);
      }
    }

    function initAll() {
      document.querySelectorAll('.foiluxmas-good-list').forEach(initFoiluxmasGoodList);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-collection-banner-with-tag-filtering"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lcbtf-filters')) {
    class LcbtfFilters extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-lcbtf-filter]'));
        this.productMap = this.buildProductMap();

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.applyFilter(button));
        });
      }

      buildProductMap() {
        const map = new Map();
        const script = this.querySelector('[data-lcbtf-products]');

        if (!script) return map;

        let products = [];

        try {
          products = JSON.parse(script.textContent);
        } catch (error) {
          products = [];
        }

        products.forEach((product) => {
          const tags = Array.isArray(product.tags) ? product.tags.map((tag) => String(tag).toLowerCase()) : [];

          if (product.id !== undefined) {
            map.set('id:' + product.id, tags);
          }

          if (product.handle) {
            map.set('handle:' + product.handle, tags);
          }
        });

        return map;
      }

      getCards() {
        return Array.from(document.querySelectorAll('[data-product-id]'));
      }

      resolveTags(card) {
        const existing = card.getAttribute('data-tags');

        if (existing !== null) {
          return existing
            .split(',')
            .map((tag) => tag.trim().toLowerCase())
            .filter(Boolean);
        }

        let tags = [];
        const productId = card.getAttribute('data-product-id');

        if (productId && this.productMap.has('id:' + productId)) {
          tags = this.productMap.get('id:' + productId);
        } else {
          const link = card.querySelector('a[href*="/products/"]');
          const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);

          if (match && this.productMap.has('handle:' + match[1])) {
            tags = this.productMap.get('handle:' + match[1]);
          }
        }

        card.setAttribute('data-tags', tags.join(', '));

        return tags;
      }

      applyFilter(activeButton) {
        const tag = activeButton.getAttribute('data-lcbtf-filter');

        this.buttons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);

          if (isActive) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        this.getCards().forEach((card) => {
          if (!tag) {
            card.classList.remove('lcbtf-hidden');
            return;
          }

          const tags = this.resolveTags(card);
          card.classList.toggle('lcbtf-hidden', !tags.includes(tag));
        });
      }
    }

    customElements.define('lcbtf-filters', LcbtfFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
